import React, { Fragment, useEffect, useState } from 'react';
import { ConfiguratorConstants } from '../../Models/Configurator/ConfiguratorConstants';
import RadioButtonInputModule from './Modules/RadioButtonInputModule';
import { useSelector } from 'react-redux';
import ProductListModule from './Modules/ProductListModule';
import TextInputModule from './Modules/TextInputModule';
import TextInputModuleWithRoundedCorners from './Modules/TextInputModuleWithRoundedCorners';
import TextInputModuleWithoutRoundedCorners from './Modules/TextInputModuleWithoutRoundedCorners';

const ConfiguratorSection = (props) => {
    const [conditionMatched, setconditionMatched] = useState(false);    

    const { configuratorValues, products } = useSelector((state) => state.productConfigurator.payload);        

    useEffect(() => {
        checkIfConditionsMatched();
    }, [configuratorValues, configuratorValues.map(x => x.value), configuratorValues.length]);

    const checkIfConditionsMatched = () => {
        let conditionsMatched = [];
        props.sectionInfo.conditions.map(x => {
            const existingConfigValue = configuratorValues.find(y => y.name === x.conditionProperty);
            if (existingConfigValue) {
                if (existingConfigValue.value !== "" && x.conditionValue.indexOf(",") > -1 ?
                    x.conditionValue.indexOf(existingConfigValue.value) > -1 : existingConfigValue.value === x.conditionValue) {
                        conditionsMatched.push(true); //setconditionMatched(true);
                }
                else {
                    conditionsMatched.push(false);
                }
            } else {
                conditionsMatched.push(false);
            }
        });

        if (conditionsMatched.some(x => !x)) {
            setconditionMatched(false);
        } 
        else {
            setconditionMatched(true);
        }
    }    

    return (
        <Fragment>
            {props.sectionInfo && (props.sectionInfo.conditions.length === 0 ||
                (props.sectionInfo.conditions.length > 0 && conditionMatched)) &&
                <>
                    {props.sectionInfo.module && props.sectionInfo.module.type === ConfiguratorConstants.RadioButtonInputModule && 
                    <RadioButtonInputModule moduleInfo={props.sectionInfo.module}></RadioButtonInputModule>}
                    {props.sectionInfo.module && props.sectionInfo.module.type === ConfiguratorConstants.ProductListModule && 
                    <ProductListModule moduleInfo={props.sectionInfo.module}></ProductListModule>}
                    {props.sectionInfo.module && props.sectionInfo.module.type === ConfiguratorConstants.TextInputModule && 
                    <TextInputModule moduleInfo={props.sectionInfo.module}></TextInputModule>}
                    {props.sectionInfo.module && props.sectionInfo.module.type === ConfiguratorConstants.WallSectionModuleWithRoundedCorners && 
                    <TextInputModuleWithRoundedCorners moduleInfo={props.sectionInfo.module}></TextInputModuleWithRoundedCorners>}
                    {props.sectionInfo.module && props.sectionInfo.module.type === ConfiguratorConstants.WallSectionModule && 
                    <TextInputModuleWithoutRoundedCorners moduleInfo={props.sectionInfo.module}></TextInputModuleWithoutRoundedCorners>}                    
                </>                
            }
        </Fragment>
    )
}

export default ConfiguratorSection;